import StatsPerSchool from './StatsPerSchool';
export default StatsPerSchool;
